import ModalVideo from 'modal-video'

$(() => {
  new ModalVideo('.js-modal-btn');

})